import http from "./http";
import { loggedIn, tokenTTL } from '../store.js';

let timer = null;
export default {
  async getTokenExpiry() {
    const response = await http.get(window.apiBaseUrl + '/auth/exp-mins');
    const expiry   = await response.text();

    return expiry;
  },

  async getJwtToken(token) {
    const form = new FormData();
    form.append('token', token)

    try {
      await http.submit(window.apiBaseUrl + `/auth/token?token=${token}`, form);
      loggedIn.update(n => true);

      const expiry = await this.getTokenExpiry();

      tokenTTL.update(n => expiry);
      this.startTimer();
    }
    catch (err) {
      console.error('Failed to get token:' + err)
    }
  },

  async refreshToken() {
    try {
      await http.put(window.apiBaseUrl + `/auth/refreshtoken`);
      const expiry = await this.getTokenExpiry();
      tokenTTL.update(n => expiry);

      this.stopTimer();
      this.startTimer();
    }
    catch (err) {
      console.error('Failed to refresh token:' + err)
    }
  },

  stopTimer() {
    clearInterval(timer);
  },

  startTimer() {
    let ttl = '';
    tokenTTL.subscribe(value => { ttl = value; });

    if (ttl) {
      let current = new Date()
      let expiry  = new Date(current.getTime() + (ttl * 60 * 1000));

      timer = setInterval(() => {
        const countdown = ((expiry - new Date()) / (1000 * 60) | 0);
        if (countdown < 5) {
          this.refreshToken();
        }
      }, 1000);
    }
  },

  logout () {
    // localStorage.setItem("selectedGroup", null);
    // localStorage.setItem("groupHasSubbedVessels", null);
    sessionStorage.clear();
    clearInterval(timer);
    loggedIn.update(n => false);
    tokenTTL.update(n => -1);
  }
}